import { forwardRef, type Ref, type SVGProps } from "react";
const IconFireOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 30q5.235 0 8.867-3.582 3.633-3.583 3.633-8.744 0-4.353-2.617-8.36-2.617-4.005-7.188-7.01-.86-.577-1.777-.058-.918.52-.918 1.56V5.81q0 1.31-.918 2.196-.917.886-2.246.886-.664 0-1.27-.289a3.3 3.3 0 0 1-1.074-.828 1.33 1.33 0 0 0-.8-.482 1.14 1.14 0 0 0-.919.212 12.3 12.3 0 0 0-3.867 4.43 12.24 12.24 0 0 0-1.406 5.74q0 5.16 3.633 8.744Q10.765 30 16 30m9.375-12.326q0 2.003-.82 3.794a9.3 9.3 0 0 1-2.086 2.903c-.082.077-.219.002-.219-.11v-.347q0-1.233-.469-2.311a6.3 6.3 0 0 0-1.367-1.965l-3.718-3.602a1 1 0 0 0-1.392 0l-3.718 3.602a6.3 6.3 0 0 0-1.367 1.965 5.7 5.7 0 0 0-.469 2.31v.348c0 .112-.137.187-.219.11a9.3 9.3 0 0 1-2.086-2.903 9 9 0 0 1-.82-3.794q0-1.927.723-3.64a9.3 9.3 0 0 1 1.543-2.48c.306-.354.822-.396 1.244-.193q.459.22.943.361.86.25 1.758.25 2.421 0 4.2-1.579 1.416-1.26 1.878-2.984c.102-.384.574-.568.87-.303q2.54 2.277 3.97 4.809 1.62 2.87 1.621 5.759m-10.07 2.677a1 1 0 0 1 1.39 0l1.532 1.483q.429.423.664.963.234.54.234 1.117 0 1.233-.918 2.118a3.06 3.06 0 0 1-2.207.886q-1.29 0-2.207-.886-.918-.885-.918-2.118 0-.616.234-1.137a3.1 3.1 0 0 1 .664-.943z" />
  </svg>
);
const ForwardRef = forwardRef(IconFireOutlineSVG);
ForwardRef.displayName = "IconFireOutline";
export { ForwardRef as IconFireOutline };
